import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import riizeKo from "./riize/ko.json";
import riizeEn from "./riize/en.json";
import aespaKo from "./aespa/ko.json";
import aespaEn from "./aespa/en.json";
import commonKo from "./common/ko.json";
import commonEn from "./common/en.json";

export const LANGUAGE_STORAGE_KEY = "2026seasonsgreetings-language";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ko: {
        riize: riizeKo,
        aespa: aespaKo,
        common: commonKo,
      },
      en: {
        riize: riizeEn,
        aespa: aespaEn,
        common: commonEn,
      },
    },
    fallbackLng: "ko",
    supportedLngs: ["ko", "en"],
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
